import React, { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import { motion } from "framer-motion";
import SplitPane, { Pane } from "split-pane-react";
import { FaEye, FaMapMarkerAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import avatarImg from "../../assets/images/avatar.png";
import { useNavigate, useLocation, Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "split-pane-react/esm/themes/default.css";
import clipboard from "clipboard-copy";
import { FaStar } from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from "../../assets/images/tripticklogowhite.png";
import { signOut, onAuthStateChanged } from "firebase/auth";

import { auth } from "../../firebase/firebaseConfig";

import { BASEURL } from "../../api";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

import {
  doc,
  collection,
  getDocs,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../utils/firebase";
import PropertyCards from "./PropertyCards";
import PropertyListingMap from "./PropertyListingMap";
import CardSlider from "./CardSlider";
import "./PropertyListing.css";
import MapboxMapForProperties from "../mapboxMapForProperties/MapboxMapForProperties";

const layoutCSS = {
  height: "100vh",
};
const PropertyListing = ({ isLoggedIn, setIsLoggedIn }) => {
  const location = useLocation();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyARr66_g-z9Rv7QQcSDmhLuh4KIDxn67h8",
  });
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [splitDirection, setSplitDirection] = useState("vertical");
  const [isHovered, setIsHovered] = useState(null);
  const [hoveredPlaceIndex, setHoveredPlaceIndex] = useState(null);
  const [sizes, setSizes] = useState([100, "5%", "auto"]);
  const [placesDetails, setPlacesDetails] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  // State to control the popup visibility
  const [showHotelInfo, setShowHotelInfo] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [staysPart, setstaysPart] = useState(true);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [contentData, setContentData] = useState(null);
  const [contentDescriptions, setContentDescriptions] = useState([]);
  const [contentname, setContentname] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setloading] = useState(true);
  const [showMenuContent, setShowMenuContent] = useState(false);
  const [isAllDataLoaded, setIsAllDataLoaded] = useState(false);
  const [mapCenterLocation, setMapCenterLocation] = useState({
    lat: 38.923937,
    lng: -101.681874,
  });
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  const handleButtonClick = () => {
    setShowMenuContent(!showMenuContent);
  };

  const [propertyData, setPropertyData] = useState([]);

  const bearerToken = localStorage.getItem("token");
  const goToLogin = () => {
    navigate(`/login`);
  };

  const signOutApiCall = async () => {
    try {
      const response = await fetch(`${BASEURL}/signoutuser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearerToken}`,
        },
        body: JSON.stringify({ token: localStorage.getItem("token") }),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }

      signOut(auth)
        .then(() => {
          setUserData({});
        })
        .catch((error) => {
          console.log({ error });
        });

      localStorage.clear();
      setIsLoggedIn(false);
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.error("Error Signing out user", error);
      // searchNearByPlace(value, isAskedQueryRelatedToItinerary);
    }
  };

  const Logout = () => {
    signOutApiCall();
  };
  const hasToken =
    localStorage.getItem("token") || localStorage.getItem("googletoken");

  const carouselSettings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  // Function to open the popup
  const openHotelInfoPopup = (hotel) => {
    setSelectedHotel(hotel);
    setShowHotelInfo(true);
  };

  // Function to close the popup
  const closeHotelInfoPopup = () => {
    setSelectedHotel(null);
    setShowHotelInfo(false);
  };

  useEffect(() => { }, []);
  const { vertical, horizontal, open } = state;
  const id = window.location.href.split("/").filter(Boolean).pop();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setSplitDirection(windowWidth <= 768 ? "horizontal" : "vertical");
    const newSizes = [...sizes];
    newSizes[1] =
      windowWidth <= 768 ? "20%" : windowWidth <= 1200 ? "8%" : "5%";
    setSizes(newSizes);
  }, [windowWidth]);

  // useEffect(() => {
  //   console.log(contentname)
  // }, [contentname])

  useEffect(() => {
    const bearerToken = localStorage.getItem("token");

    fetch(`${BASEURL}/fetch-property-listing-data`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // if (data.message === "Auth failed!") {
        //   localStorage.clear();
        //   setIsLoggedIn(false);
        //   navigate("/");
        //   window.location.reload();
        // }
        // if (data.message === "Token Expired!") {
        //   localStorage.clear();
        //   setIsLoggedIn(false);
        //   navigate("/");
        //   window.location.reload();
        // }
        // Handle the response data, for example, set it in the state

        let myData = data;

        myData.result.sort((a, b) => {
          const nameA = a.property_loc_name.toUpperCase(); // ignore case
          const nameB = b.property_loc_name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0; // names must be equal
        });

        // console.log("myData",myData)
        setPropertyData(myData);
        setIsAllDataLoaded(true);
        setTriggerAnimation(true);
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error fetching data:", error);
      });
  }, []);

  // useEffect(() => {
  //   console.log("propertyData", propertyData);
  // }, [propertyData]);

  return (
    <>
      <header className="property">
        <div className="container-fluid">
          <div className="navber">
            <div className="brand-logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="112"
                height="27"
                viewBox="0 0 112 27"
                fill="none"
                onClick={() => {
                  navigate(`/`);
                }}
              >
                <path
                  d="M87.8547 20.989C85.7195 20.989 83.9684 20.2914 82.6013 18.8962C81.2343 17.5009 80.5507 15.8484 80.5507 13.9385C80.5507 11.8226 81.2432 10.1317 82.6295 8.86828C84.3742 7.27718 86.7692 6.69733 89.0848 7.03398C90.2893 7.20934 91.5732 7.674 92.4756 8.51883C93.2821 9.27405 93.9771 10.4645 93.5944 11.5948C93.5675 11.6729 93.5368 11.7497 93.5009 11.8239C92.98 12.9055 91.4951 12.9017 90.5786 12.373C89.2781 11.6229 89.0259 10.0792 88.1363 8.98093C87.7804 8.54059 87.3772 8.32042 86.9279 8.32042C86.3468 8.33962 85.8744 8.64811 85.5096 9.24717C85.1448 9.84624 84.9617 10.5861 84.9617 11.4668C84.9617 13.3024 85.3778 14.7719 86.2123 15.8778C87.0457 16.9825 88.1555 17.5355 89.5417 17.5355C90.265 17.5355 90.9728 17.3409 91.5783 16.9415C91.9022 16.729 92.1902 16.4654 92.4436 16.1722C92.6843 15.8957 92.9032 15.5604 93.3294 15.6615C93.4318 15.6858 93.5291 15.737 93.5995 15.8164C93.7032 15.9341 93.7326 16.1005 93.7301 16.2567C93.7006 17.547 93.0696 18.7285 92.1274 19.5848C91.097 20.5218 89.6736 20.989 87.8572 20.989H87.8547Z"
                  fill="black"
                />
                <path
                  d="M91.5412 12.3398C91.6189 12.3398 91.682 12.2767 91.682 12.199C91.682 12.1212 91.6189 12.0582 91.5412 12.0582C91.4634 12.0582 91.4004 12.1212 91.4004 12.199C91.4004 12.2767 91.4634 12.3398 91.5412 12.3398Z"
                  fill="black"
                />
                <path
                  d="M17.351 4.69149C17.351 4.69149 17.351 4.6851 17.351 4.68254L16.8569 1.25457C16.8006 0.674708 16.4819 0.384139 15.902 0.384139H1.46053C0.879388 0.384139 0.561942 0.674708 0.50562 1.25457L0.011516 4.68254C0.011516 4.68254 0.011516 4.68893 0.011516 4.69149C0.00511581 4.73885 0 4.7875 0 4.83614C0 5.41728 0.471053 5.88834 1.05219 5.88834C1.41573 5.88834 1.73574 5.70401 1.92519 5.42368C2.19784 5.02943 2.3476 4.65949 2.60617 4.19867C2.83402 3.7929 3.15019 3.37817 3.49709 3.02232C3.84398 2.66646 4.23183 2.48853 4.66321 2.48853H6.1519V17.6635C6.1519 17.6712 6.1519 17.6776 6.1519 17.6878C6.1519 18.9282 5.08306 19.3378 4.95633 19.9791C4.94865 20.0188 4.94354 20.0597 4.94354 20.1032C4.94354 20.4373 5.21362 20.7074 5.54771 20.7074H11.8161C12.1502 20.7074 12.4203 20.4373 12.4203 20.1032C12.4203 20.061 12.4152 20.02 12.4075 19.9791C12.2808 19.3391 11.2119 18.9294 11.2119 17.6878C11.2119 17.2807 11.2119 2.48982 11.2119 2.48982H12.7006C13.132 2.48982 13.5198 2.66774 13.8667 3.02359C14.2136 3.37945 14.5298 3.79418 14.7576 4.19996C15.0162 4.66077 15.166 5.02943 15.4386 5.42496C15.6281 5.70529 15.9481 5.88962 16.3116 5.88962C16.8928 5.88962 17.3638 5.41856 17.3638 4.83742C17.3638 4.7875 17.3587 4.74014 17.3523 4.69277L17.351 4.69149Z"
                  fill="black"
                />
                <path
                  d="M33.5628 6.16995C35.2383 6.16995 36.5965 4.81171 36.5965 3.13624C36.5965 1.46077 35.2383 0.102527 33.5628 0.102527C31.8873 0.102527 30.5291 1.46077 30.5291 3.13624C30.5291 4.81171 31.8873 6.16995 33.5628 6.16995Z"
                  fill="black"
                />
                <path
                  d="M37.5373 19.9791C37.4106 19.3391 36.3418 18.9294 36.3418 17.6878V7.67272C36.3418 7.37319 36.2291 7.15814 36.0051 7.0263C35.7798 6.89573 35.4713 6.91365 35.0784 7.08262L30.8401 9.15885C30.3102 9.4187 30.154 10.101 30.5188 10.5656C30.5982 10.6667 30.6776 10.7679 30.7518 10.8613C31.1205 11.3247 31.3137 11.7932 31.3137 12.2796V17.6878C31.3137 18.9282 30.2436 19.3378 30.1169 19.9791C30.1092 20.0188 30.1041 20.0597 30.1041 20.1032C30.1041 20.4373 30.3742 20.7074 30.7083 20.7074H31.3125V20.6985C31.3125 20.6985 31.3176 20.7074 31.3227 20.7074H36.3315C36.3315 20.7074 36.3418 20.7023 36.3418 20.6972V20.7074H36.9459C37.28 20.7074 37.5501 20.4373 37.5501 20.1032C37.5501 20.061 37.545 20.02 37.5373 19.9791Z"
                  fill="black"
                />
                <path
                  d="M111.523 19.6066C111.361 19.4095 111.144 19.261 110.943 19.1112C110.465 18.7554 110.258 18.4789 110.165 18.347L105.642 11.8853C105.651 11.8777 105.66 11.8713 105.669 11.8636C106.071 11.5346 106.473 11.2056 106.875 10.8754C107.498 10.3647 108.12 9.85392 108.742 9.3419C108.973 9.15117 109.203 8.96172 109.434 8.771C109.747 8.50987 110.065 8.23338 110.085 7.7956C110.09 7.68552 110.075 7.5716 110.02 7.47687C109.901 7.27591 109.66 7.22726 109.445 7.22599L105.522 7.20678C105.13 7.20678 104.644 7.1287 104.431 7.45767C104.371 7.54984 104.352 7.66376 104.349 7.77384C104.335 8.49067 105.034 8.88364 105.27 9.49807C105.323 9.63759 105.346 9.79376 105.306 9.93712C105.242 10.1637 104.39 10.9087 104.215 11.0584C103.519 11.6562 101.748 13.0937 101.259 13.5136V0.73231C101.259 0.43278 101.147 0.217733 100.923 0.0858887C100.697 -0.044676 100.389 -0.026755 99.9959 0.142211L95.7577 2.21845C95.2277 2.47829 95.0715 3.16056 95.4364 3.62521C95.5157 3.72634 95.5951 3.82746 95.6693 3.92091C96.038 4.38428 96.2313 4.85278 96.2313 5.33919V17.6852C96.23 18.9256 95.1612 19.3352 95.0344 19.9765C95.0267 20.0162 95.0216 20.0572 95.0216 20.1007C95.0216 20.4348 95.2917 20.7049 95.6258 20.7049H101.863C102.198 20.7049 102.468 20.4348 102.468 20.1007C102.468 20.0584 102.463 20.0175 102.455 19.9765C102.328 19.3365 101.259 18.9269 101.259 17.6852V15.9572L102.663 14.6656C102.663 14.6656 105.135 18.3445 105.135 18.3457C105.451 18.8168 104.91 19.2392 104.694 19.6117C104.58 19.8088 104.505 20.0418 104.552 20.2658C104.618 20.5845 104.893 20.7049 105.19 20.7049H110.627C110.943 20.6997 111.431 20.7356 111.619 20.5269C111.684 20.4553 111.721 20.3605 111.736 20.2645C111.772 20.029 111.672 19.7884 111.521 19.604L111.523 19.6066Z"
                  fill="black"
                />
                <path
                  d="M25.9209 6.94309C24.3145 6.94309 22.9026 7.94921 22.2446 9.72464V7.66632C22.2446 7.36679 22.132 7.15174 21.908 7.0199C21.6827 6.88933 21.3742 6.90725 20.9812 7.07622L17.5149 9.16013C16.9849 9.41998 16.8288 10.1022 17.1936 10.5669C17.2729 10.668 17.3523 10.7691 17.4265 10.8626C17.7952 11.326 17.9885 11.7945 17.9885 12.2809V17.6891C17.9885 18.9294 16.9196 19.3391 16.7929 19.9804C16.7852 20.02 16.7801 20.061 16.7801 20.1045C16.7801 20.4386 17.0502 20.7087 17.3843 20.7087H17.9885V20.6985C17.9885 20.6985 17.9923 20.7087 17.9987 20.7087H23.357C23.6911 20.7087 23.9612 20.4386 23.9612 20.1045C23.9612 20.0623 23.9561 20.0213 23.9484 19.9804C23.8332 19.3992 22.9435 19.0062 22.781 18.0104L22.7528 17.6904V12.423C22.7528 10.6258 23.0984 9.72591 23.7922 9.72591C24.0917 9.72591 24.3158 9.86159 24.4668 10.133C24.6166 10.4043 24.6601 10.6949 24.7945 11.029C24.9212 11.3452 25.0633 11.5717 25.3334 11.8175C25.6547 12.1094 26.1321 12.35 26.7133 12.35C27.7834 12.35 28.8548 11.5052 28.8548 9.87312C28.8548 8.24106 27.5952 6.94437 25.9248 6.94437L25.9209 6.94309Z"
                  fill="black"
                />
                <path
                  d="M53.639 8.8094C52.4857 7.50375 50.974 6.85093 49.1064 6.85093C48.172 6.85093 47.1466 7.04806 46.3927 7.6484C46.0855 7.89289 45.7271 8.29482 45.553 8.69164V7.5716C45.553 7.27206 45.4403 7.05702 45.2163 6.92517C44.991 6.79461 44.6825 6.81253 44.2896 6.9815L40.0513 9.05901C39.5214 9.31886 39.3652 10.0011 39.7301 10.4645C39.8094 10.5669 39.8888 10.6667 39.963 10.7602C40.3317 11.2236 40.525 11.6921 40.525 12.1785L40.5301 23.617C40.5301 24.8573 39.4612 25.267 39.3345 25.9083C39.3268 25.9479 39.3217 25.9889 39.3217 26.0324C39.3217 26.3665 39.5918 26.6366 39.9259 26.6366H46.152C46.4861 26.6366 46.7562 26.3665 46.7562 26.0324C46.7562 25.9902 46.7511 25.9492 46.7434 25.9083C46.6167 25.2695 45.5517 24.8599 45.5479 23.6247C45.5504 20.3362 45.553 11.4962 45.553 11.4962C45.6067 10.6514 45.7514 10.2494 45.9408 9.94224C46.3005 9.35982 46.9047 9.02573 47.6766 9.02573C48.515 9.02573 49.1781 9.4379 49.6645 10.2622C50.1509 11.0866 50.3941 12.2143 50.3941 13.6441C50.3941 15.1572 50.1931 18.0283 48.3601 18.5505C47.7355 18.7285 47.0647 18.2305 46.5783 18.8731C46.3709 19.1483 46.3325 19.5413 46.4849 19.8511C46.6743 20.2351 47.0954 20.4412 47.5025 20.5743C49.5506 21.2425 52.0953 20.6473 53.5686 19.0421C54.7565 17.748 55.3709 16.0609 55.3709 13.9437C55.3709 11.8265 54.7936 10.1163 53.6403 8.81068L53.639 8.8094Z"
                  fill="black"
                />
                <path
                  d="M71.1718 4.69149C71.1718 4.69149 71.1718 4.6851 71.1718 4.68254L70.6777 1.25457C70.6214 0.674708 70.3027 0.384139 69.7228 0.384139H55.2813C54.7002 0.384139 54.3827 0.674708 54.3264 1.25457L53.8323 4.68254C53.8323 4.68254 53.8323 4.68893 53.8323 4.69149C53.8259 4.73885 53.8208 4.7875 53.8208 4.83614C53.8208 5.41728 54.2919 5.88834 54.873 5.88834C55.2365 5.88834 55.5565 5.70401 55.746 5.42368C56.0186 5.02943 56.1684 4.65949 56.427 4.19867C56.6548 3.7929 56.971 3.37817 57.3179 3.02232C57.6648 2.66646 58.0526 2.48853 58.484 2.48853H59.9727V17.6635C59.9727 17.6712 59.9727 17.6776 59.9727 17.6878C59.9727 18.9282 58.9039 19.3378 58.7771 19.9791C58.7695 20.0188 58.7643 20.0597 58.7643 20.1032C58.7643 20.4373 59.0344 20.7074 59.3685 20.7074H65.6369C65.971 20.7074 66.2411 20.4373 66.2411 20.1032C66.2411 20.061 66.236 20.02 66.2283 19.9791C66.1016 19.3391 65.0327 18.9294 65.0327 17.6878C65.0327 17.2807 65.0327 2.48982 65.0327 2.48982H66.5214C66.9528 2.48982 67.3406 2.66774 67.6875 3.02359C68.0344 3.37945 68.3506 3.79418 68.5784 4.19996C68.837 4.66077 68.9868 5.02943 69.2594 5.42496C69.4489 5.70529 69.7689 5.88962 70.1324 5.88962C70.7136 5.88962 71.1846 5.41856 71.1846 4.83742C71.1846 4.7875 71.1795 4.74014 71.1731 4.69277L71.1718 4.69149Z"
                  fill="black"
                />
                <path
                  d="M75.6033 6.16995C77.2788 6.16995 78.637 4.81171 78.637 3.13624C78.637 1.46077 77.2788 0.102527 75.6033 0.102527C73.9279 0.102527 72.5696 1.46077 72.5696 3.13624C72.5696 4.81171 73.9279 6.16995 75.6033 6.16995Z"
                  fill="black"
                />
                <path
                  d="M79.5779 19.9791C79.4512 19.3391 78.3823 18.9294 78.3823 17.6878V7.67272C78.3823 7.37319 78.2697 7.15814 78.0457 7.0263C77.8204 6.89573 77.5119 6.91365 77.1189 7.08262L72.8807 9.15885C72.3507 9.4187 72.1946 10.101 72.5594 10.5656C72.6388 10.6667 72.7181 10.7679 72.7924 10.8613C73.161 11.3247 73.3543 11.7932 73.3543 12.2796V17.6878C73.3543 18.9282 72.2842 19.3378 72.1575 19.9791C72.1498 20.0188 72.1447 20.0597 72.1447 20.1032C72.1447 20.4373 72.4147 20.7074 72.7488 20.7074H73.353V20.6985C73.353 20.6985 73.3581 20.7074 73.3633 20.7074H78.3721C78.3721 20.7074 78.3823 20.7023 78.3823 20.6972V20.7074H78.9865C79.3206 20.7074 79.5907 20.4373 79.5907 20.1032C79.5907 20.061 79.5856 20.02 79.5779 19.9791Z"
                  fill="black"
                />
              </svg>
            </div>

            <div className="nav-menu">
              {!hasToken ? (
                <>
                  <Link
                    className=" property-blue-link"
                    to="/property-listing"
                  >
                    <span className="property-blue">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.34921 0.890914C8.12101 0.829127 7.88048 0.829127 7.65228 0.890914C7.38737 0.96264 7.16434 1.13774 6.98634 1.2775L6.93658 1.31644L2.36324 4.87342C2.11215 5.06828 1.89094 5.23995 1.7261 5.46282C1.58144 5.6584 1.47368 5.87874 1.4081 6.11301C1.33338 6.37995 1.33369 6.65996 1.33403 6.97779L1.33408 11.8924C1.33406 12.2438 1.33405 12.547 1.35446 12.7967C1.37599 13.0602 1.42353 13.3224 1.55206 13.5746C1.74381 13.951 2.04977 14.2569 2.4261 14.4487C2.67835 14.5772 2.9405 14.6248 3.20406 14.6463C3.45377 14.6667 3.75694 14.6667 4.10837 14.6667H11.8931C12.2445 14.6667 12.5477 14.6667 12.7974 14.6463C13.061 14.6248 13.3231 14.5772 13.5754 14.4487C13.9517 14.2569 14.2577 13.951 14.4494 13.5746C14.578 13.3224 14.6255 13.0602 14.647 12.7967C14.6674 12.547 14.6674 12.2438 14.6674 11.8924L14.6675 6.97779C14.6678 6.65996 14.6681 6.37996 14.5934 6.11301C14.5278 5.87874 14.42 5.6584 14.2754 5.46282C14.1105 5.23995 13.8893 5.06828 13.6382 4.87342L9.06491 1.31644L9.01516 1.2775C8.83715 1.13775 8.61412 0.962641 8.34921 0.890914ZM6.06371 9.16717C5.97194 8.8106 5.60849 8.59594 5.25192 8.68772C4.89535 8.77949 4.68069 9.14295 4.77246 9.49951C5.14246 10.9371 6.44663 12 8.00074 12C9.55486 12 10.859 10.9371 11.229 9.49951C11.3208 9.14295 11.1061 8.77949 10.7496 8.68772C10.393 8.59594 10.0295 8.8106 9.93777 9.16717C9.71572 10.0299 8.93175 10.6667 8.00074 10.6667C7.06974 10.6667 6.28577 10.0299 6.06371 9.16717Z"
                          fill="#0098FF"
                        />
                      </svg>
                    </span>
                    Properties
                  </Link>
                  <Link className="property-btn" to="https://blog.triptick.ai/" target="_blank">
                    Blog
                  </Link>
                  <Link className="login-btn" to="/login">
                    Log in
                  </Link>
                  <Link className="sign-up-btn" to="/signup">
                    Sign up
                  </Link>
                </>
              ) : (
                <>
                  {/* <button className="sign-up-btn" onClick={Logout}>
                    Log out
                  </button> */}

                  <Link
                    className=" property-blue-link"
                    to="/property-listing"
                  >
                    <span className="property-blue">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.34921 0.890914C8.12101 0.829127 7.88048 0.829127 7.65228 0.890914C7.38737 0.96264 7.16434 1.13774 6.98634 1.2775L6.93658 1.31644L2.36324 4.87342C2.11215 5.06828 1.89094 5.23995 1.7261 5.46282C1.58144 5.6584 1.47368 5.87874 1.4081 6.11301C1.33338 6.37995 1.33369 6.65996 1.33403 6.97779L1.33408 11.8924C1.33406 12.2438 1.33405 12.547 1.35446 12.7967C1.37599 13.0602 1.42353 13.3224 1.55206 13.5746C1.74381 13.951 2.04977 14.2569 2.4261 14.4487C2.67835 14.5772 2.9405 14.6248 3.20406 14.6463C3.45377 14.6667 3.75694 14.6667 4.10837 14.6667H11.8931C12.2445 14.6667 12.5477 14.6667 12.7974 14.6463C13.061 14.6248 13.3231 14.5772 13.5754 14.4487C13.9517 14.2569 14.2577 13.951 14.4494 13.5746C14.578 13.3224 14.6255 13.0602 14.647 12.7967C14.6674 12.547 14.6674 12.2438 14.6674 11.8924L14.6675 6.97779C14.6678 6.65996 14.6681 6.37996 14.5934 6.11301C14.5278 5.87874 14.42 5.6584 14.2754 5.46282C14.1105 5.23995 13.8893 5.06828 13.6382 4.87342L9.06491 1.31644L9.01516 1.2775C8.83715 1.13775 8.61412 0.962641 8.34921 0.890914ZM6.06371 9.16717C5.97194 8.8106 5.60849 8.59594 5.25192 8.68772C4.89535 8.77949 4.68069 9.14295 4.77246 9.49951C5.14246 10.9371 6.44663 12 8.00074 12C9.55486 12 10.859 10.9371 11.229 9.49951C11.3208 9.14295 11.1061 8.77949 10.7496 8.68772C10.393 8.59594 10.0295 8.8106 9.93777 9.16717C9.71572 10.0299 8.93175 10.6667 8.00074 10.6667C7.06974 10.6667 6.28577 10.0299 6.06371 9.16717Z"
                          fill="#0098FF"
                        />
                      </svg>
                    </span>
                    Properties
                  </Link>
                  <Link className="property-btn" to="https://blog.triptick.ai/" target="_blank">
                    Blog
                  </Link>
                  <div className="header-dropdown">
                    <input
                      type="checkbox"
                      className="header-dd-input"
                      id="test"
                    />
                    <div className="header-dd-button">
                      <div className="header-inner-button">
                        <span className="dropdown-image">
                          <img src={avatarImg} alt="" />
                        </span>
                        {localStorage.getItem("fullname")}
                        <span className="dropdown-arrow">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              width="24"
                              height="24"
                              rx="12"
                              fill="#E6E0D6"
                            />
                            <path
                              d="M17.8528 9.85393L12.8534 14.8534C12.8069 14.8999 12.7518 14.9367 12.6911 14.9619C12.6304 14.9871 12.5654 15 12.4997 15C12.434 15 12.3689 14.9871 12.3082 14.9619C12.2475 14.9367 12.1924 14.8999 12.146 14.8534L7.14651 9.85393C7.0527 9.76012 7 9.63289 7 9.50022C7 9.36755 7.0527 9.24032 7.14651 9.14651C7.24032 9.0527 7.36755 9 7.50022 9C7.63289 9 7.76012 9.0527 7.85393 9.14651L12.4997 13.7929L17.1454 9.14651C17.1918 9.10006 17.247 9.06322 17.3077 9.03808C17.3684 9.01294 17.4334 9 17.4991 9C17.5648 9 17.6298 9.01294 17.6905 9.03808C17.7512 9.06322 17.8064 9.10006 17.8528 9.14651C17.8993 9.19296 17.9361 9.24811 17.9612 9.3088C17.9864 9.36948 17.9993 9.43453 17.9993 9.50022C17.9993 9.56591 17.9864 9.63096 17.9612 9.69165C17.9361 9.75234 17.8993 9.80748 17.8528 9.85393Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>

                    <ul className="header-dd-menu">
                      {/* <li className="profile">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M15.9834 5.15884L12.8412 2.01728C12.7367 1.91279 12.6127 1.8299 12.4762 1.77334C12.3397 1.71679 12.1933 1.68768 12.0456 1.68768C11.8978 1.68768 11.7515 1.71679 11.615 1.77334C11.4785 1.8299 11.3545 1.91279 11.25 2.01728L2.57977 10.6875C2.47485 10.7916 2.39167 10.9155 2.33506 11.052C2.27844 11.1885 2.24953 11.335 2.25001 11.4827V14.625C2.25001 14.9234 2.36853 15.2095 2.57951 15.4205C2.79049 15.6315 3.07664 15.75 3.37501 15.75H15.1875C15.3367 15.75 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3367 15.75 15.1875C15.75 15.0383 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.625 15.1875 14.625H8.10844L15.9834 6.75001C16.0879 6.64554 16.1708 6.52151 16.2274 6.385C16.2839 6.2485 16.313 6.10219 16.313 5.95443C16.313 5.80667 16.2839 5.66036 16.2274 5.52385C16.1708 5.38734 16.0879 5.26331 15.9834 5.15884ZM6.51727 14.625H3.37501V11.4827L9.56251 5.29525L12.7048 8.43751L6.51727 14.625ZM13.5 7.64228L10.3584 4.50001L12.0459 2.81251L15.1875 5.95478L13.5 7.64228Z"
                              fill="#3B352B"
                            />
                          </svg>
                        </span>
                        Profile
                      </li> */}
                      <li
                        className="trip-black"
                        onClick={() => {
                          navigate("/my-trips");
                        }}
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M14.0625 15.75H10.5848C11.169 15.2284 11.72 14.6706 12.2344 14.0801C14.1645 11.8603 15.1875 9.52031 15.1875 7.3125C15.1875 5.67147 14.5356 4.09766 13.3752 2.93728C12.2148 1.7769 10.641 1.125 9 1.125C7.35897 1.125 5.78516 1.7769 4.62478 2.93728C3.4644 4.09766 2.8125 5.67147 2.8125 7.3125C2.8125 9.52031 3.83273 11.8603 5.76562 14.0801C6.28004 14.6706 6.83096 15.2284 7.41516 15.75H3.9375C3.78832 15.75 3.64524 15.8093 3.53975 15.9148C3.43426 16.0202 3.375 16.1633 3.375 16.3125C3.375 16.4617 3.43426 16.6048 3.53975 16.7102C3.64524 16.8157 3.78832 16.875 3.9375 16.875H14.0625C14.2117 16.875 14.3548 16.8157 14.4602 16.7102C14.5657 16.6048 14.625 16.4617 14.625 16.3125C14.625 16.1633 14.5657 16.0202 14.4602 15.9148C14.3548 15.8093 14.2117 15.75 14.0625 15.75ZM3.9375 7.3125C3.9375 5.96984 4.47087 4.68217 5.42027 3.73277C6.36967 2.78337 7.65734 2.25 9 2.25C10.3427 2.25 11.6303 2.78337 12.5797 3.73277C13.5291 4.68217 14.0625 5.96984 14.0625 7.3125C14.0625 11.3365 10.1623 14.6953 9 15.6094C7.83773 14.6953 3.9375 11.3365 3.9375 7.3125ZM11.8125 7.3125C11.8125 6.75624 11.6475 6.21247 11.3385 5.74996C11.0295 5.28745 10.5902 4.92696 10.0763 4.71409C9.56238 4.50122 8.99688 4.44552 8.45131 4.55404C7.90574 4.66256 7.4046 4.93043 7.01126 5.32376C6.61793 5.7171 6.35006 6.21824 6.24154 6.76381C6.13302 7.30938 6.18872 7.87488 6.40159 8.3888C6.61446 8.90271 6.97495 9.34197 7.43746 9.65101C7.89997 9.96005 8.44374 10.125 9 10.125C9.74592 10.125 10.4613 9.82868 10.9887 9.30124C11.5162 8.77379 11.8125 8.05842 11.8125 7.3125ZM7.3125 7.3125C7.3125 6.97874 7.41147 6.65248 7.5969 6.37498C7.78232 6.09747 8.04587 5.88118 8.35422 5.75345C8.66257 5.62573 9.00187 5.59231 9.32922 5.65742C9.65656 5.72254 9.95724 5.88326 10.1932 6.11926C10.4292 6.35526 10.59 6.65594 10.6551 6.98328C10.7202 7.31063 10.6868 7.64993 10.559 7.95828C10.4313 8.26663 10.215 8.53018 9.93752 8.7156C9.66002 8.90103 9.33376 9 9 9C8.55245 9 8.12322 8.82221 7.80676 8.50574C7.49029 8.18928 7.3125 7.76005 7.3125 7.3125Z"
                              fill="#3b352b"
                            />
                          </svg>
                        </span>
                        My Trips
                      </li>
                      {/* <li className="property-blue-dw" onClick={() => {
                          navigate("/property-listing");
                        }}>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            stroke="#000"
                          >
                            <path
                              d="M6.09451 10.5C6.42755 11.794 7.60212 12.75 9 12.75C10.3979 12.75 11.5725 11.794 11.9055 10.5M8.26327 2.07306L3.17654 6.0294C2.83652 6.29387 2.6665 6.4261 2.54402 6.5917C2.43552 6.73839 2.3547 6.90365 2.30552 7.07935C2.25 7.2777 2.25 7.49308 2.25 7.92385V13.35C2.25 14.1901 2.25 14.6102 2.41349 14.931C2.5573 15.2133 2.78677 15.4427 3.06901 15.5866C3.38988 15.75 3.80992 15.75 4.65 15.75H13.35C14.1901 15.75 14.6101 15.75 14.931 15.5866C15.2132 15.4427 15.4427 15.2133 15.5865 14.931C15.75 14.6102 15.75 14.1901 15.75 13.35V7.92385C15.75 7.49308 15.75 7.2777 15.6945 7.07935C15.6453 6.90365 15.5645 6.73839 15.456 6.5917C15.3335 6.4261 15.1635 6.29387 14.8235 6.02941L9.73673 2.07306C9.47324 1.86812 9.34149 1.76565 9.19601 1.72626C9.06765 1.69151 8.93235 1.69151 8.80399 1.72626C8.65851 1.76565 8.52677 1.86812 8.26327 2.07306Z"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        Properties
                      </li> */}
                      <li className="logout" onClick={Logout}>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M7.875 15.1875C7.875 15.3367 7.81574 15.4798 7.71025 15.5852C7.60476 15.6907 7.46168 15.75 7.3125 15.75H3.375C3.07663 15.75 2.79048 15.6315 2.5795 15.4205C2.36853 15.2095 2.25 14.9234 2.25 14.625V3.375C2.25 3.07663 2.36853 2.79048 2.5795 2.5795C2.79048 2.36853 3.07663 2.25 3.375 2.25H7.3125C7.46168 2.25 7.60476 2.30926 7.71025 2.41475C7.81574 2.52024 7.875 2.66332 7.875 2.8125C7.875 2.96168 7.81574 3.10476 7.71025 3.21025C7.60476 3.31574 7.46168 3.375 7.3125 3.375H3.375V14.625H7.3125C7.46168 14.625 7.60476 14.6843 7.71025 14.7898C7.81574 14.8952 7.875 15.0383 7.875 15.1875ZM15.5855 8.60203L12.773 5.78953C12.6674 5.68398 12.5243 5.62469 12.375 5.62469C12.2257 5.62469 12.0826 5.68398 11.977 5.78953C11.8715 5.89508 11.8122 6.03823 11.8122 6.1875C11.8122 6.33677 11.8715 6.47992 11.977 6.58547L13.8298 8.4375H7.3125C7.16332 8.4375 7.02024 8.49676 6.91475 8.60225C6.80926 8.70774 6.75 8.85082 6.75 9C6.75 9.14918 6.80926 9.29226 6.91475 9.39775C7.02024 9.50324 7.16332 9.5625 7.3125 9.5625H13.8298L11.977 11.4145C11.8715 11.5201 11.8122 11.6632 11.8122 11.8125C11.8122 11.9618 11.8715 12.1049 11.977 12.2105C12.0826 12.316 12.2257 12.3753 12.375 12.3753C12.5243 12.3753 12.6674 12.316 12.773 12.2105L15.5855 9.39797C15.6378 9.34573 15.6793 9.28369 15.7076 9.2154C15.7359 9.14712 15.7504 9.07392 15.7504 9C15.7504 8.92608 15.7359 8.85288 15.7076 8.7846C15.6793 8.71631 15.6378 8.65427 15.5855 8.60203Z"
                              fill="#868179"
                            />
                          </svg>
                        </span>
                        Logout
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
            <div className="result-heading-wrapper">
              <div className="heading-child">
                <h2 className="result-heading">Properties</h2>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="result-section my-property-section">
        <div className="container-fluid">
          <motion.div
            initial={{ x: 0, y: "100%", opacity: 1 }}
            animate={{
              x: triggerAnimation ? 0 : 0,
              y: triggerAnimation ? "0%" : "100%",
              opacity: triggerAnimation ? 1 : 1,
            }}
            transition={{ duration: 2 }}
          >
            <div className="result-wrapper">
              <div className="left-result">
                <div className="result-heading-wrapper">
                  <div className="heading-child">
                    <h2 className="result-heading">Properties</h2>
                  </div>
                </div>
                <div className="property-grid">
                  {isAllDataLoaded == true &&
                    propertyData.result &&
                    propertyData.result.map((location) => (
                      <div
                        key={location.property_loc_name}
                        className="location-container"
                      >
                        <h2 className="property-location-name">
                          {location.property_loc_name}
                          <span>{location.properties.length}</span>
                        </h2>

                        <div className="property-listing property-list-slider">
                          <CardSlider properties={location.properties} />
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="right-map-wrapper right-property-wrapper">
                {isLoaded ? (
                  <>
                    {propertyData.result && (
                      <MapboxMapForProperties data={propertyData.result} />
                    )}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default PropertyListing;
